<template>
  <div>
    <div
      v-if="isPreviewsLoading"
      class="text-center mt-5"
    >
      <b-spinner variant="primary" />
      <p class="mt-2">
        Generating Previews...
      </p>
    </div>

    <div v-if="previews.length">
      <div class="card mt-3">
        <div class="card-body d-flex justify-content-between">
          <div class="align-items-center">
            <h3 class="card-title">
              Name: {{ creative.name }}
            </h3>
            <h4 class="card-subtitle mb-2 text-muted">
              Status: <span :class="walmart.getStatusBadge(creative.status)">{{ creative.status }}</span>
            </h4>
            <h4 class="card-subtitle mb-2 text-muted">
              Layout:
              <a
                v-if="creative.layout_link"
                :href="creative.layout_link"
                target="_blank"
              >
                Link
              </a>
              <span v-else>N/A</span>
            </h4>
          </div>
          <div class="card-text">
            <button
              class="btn btn-primary btn-sm mx-2"
              :disabled="creative?.isLoading"
              @click="submitCreative(creative)"
            >
              <span
                v-if="creative?.isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Submit
            </button>
            <button
              class="btn btn-success btn-sm mx-2"
              @click="openShareModal"
            >
              <i class="fas fa-share-alt mr-1" />
              Share
            </button>
            <!-- todo add delete -->
            <!-- <button
              class="btn btn-danger btn-sm mx-2"
              :disabled="creative?.isLoading"
            >
              <span
                v-if="creative?.isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              <i class="fas fa-trash-alt" />
            </button> -->
          </div>
        </div>
      </div>
      <div
        v-for="(preview, index) in previews"
        :key="index"
        class="mt-3 mb-2 border rounded p-3"
      >
        <h3>{{ adUnitTypes[preview.name] }}</h3>
        <img
          :src="preview.url"
          alt="preview"
          class="img-fluid"
        >
      </div>
    </div>

    <WalmartShareModal
      ref="shareModal"
      :creative-id="form.creative_id"
      :platform-id="form.platform_id"
      :company-id="form.company_id"
    />
  </div>
</template>

<script>
import * as walmart from '@frontend/components/helpers/walmart-helpers.js';
import { adUnitTypes } from '@frontend/constants/walmart-constants.js';
import WalmartShareModal from '@frontend/components/walmart/WalmartShareModal.vue';

export default {
  name: 'WalmartShowPreview',
  components: {
    WalmartShareModal
  },
  data() {
    return {
      walmart,
      adUnitTypes,
      form: {
        creative_id: null,
        platform_id: null,
        company_id: null,
      },
      previews: [],
      creative: {
        name: '',
        status: '',
        creativeId: '',
      },
      errors: {},
      isPreviewsLoading: false,
      enableNotification: false,
      hasPreviewData: false
    }
  },
  async mounted() {
    await this.getParams();
    await this.getCreativeData();
    await this.showNotificationPreferenceModal();
  },
  methods: {
    async getParams() {
      const urlParams = new URLSearchParams(window.location.search);
      this.form.creative_id = urlParams.get('creative_id');
      this.form.platform_id = urlParams.get('platform_id');
      this.form.company_id = urlParams.get('company_id');
    },

    async fetchPreviews() {
      this.isPreviewsLoading = true;

      try {
        const { data } = await axios.post('/walmart/fetch-previews', {
          ...this.form,
          enable_notification: this.enableNotification
        });

        if (data.status === 'error') {
          toastr.options = {
            timeOut: 0,
            extendedTimeOut: 0
          };
          toastr.error(data.message);
          return;
        }

        if (data.status === 'failed') {
          toastr.options = {
            timeOut: 0,
            extendedTimeOut: 0
          };

          toastr.error(data.message);

          return;
        }

        data.forEach((preview) => {
          let newPreview = {};

          newPreview.name = preview.name;

          newPreview.url = preview.image;

          this.previews.push(newPreview);
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isPreviewsLoading = false;
      }
    },

    async getCreativeData() {
      this.form.is_specific_creative = true;

      const { data } = await axios.post('/walmart/get-creatives', this.form);

      if (data?.result?.original?.status === 'error') {
        console.log('error', data.result.original.message);
      }

      if (data?.status === 'error') {
        console.log('error', data.message);
      }

      const creative = data.data.response[0];

      this.creative.name = creative.name;
      this.creative.status = creative.status;
      this.creative.creativeId = creative.creativeId;
      this.creative.layout_link = creative.layout_link;

      this.hasPreviewData = creative.has_preview_data;
    },

    async submitCreative(creative) {
      await walmart.submitCreative.call(this, creative);

      await this.getCreativeData();
    },

    openShareModal() {
      this.$refs.shareModal.show();
    },

    async showNotificationPreferenceModal() {
      if (!this.hasPreviewData) {
        const result = await Swal.fire({
          title: 'Preview Generation',
          text: 'Would you like to receive a notification when the preview is ready?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, notify me',
          cancelButtonText: 'No, I\'ll wait',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-primary'
          }
        });

        this.enableNotification = result.isConfirmed;

        if (this.enableNotification) {
          toastr.info('Preview generation started. You will be notified when it\'s ready!');
        }
      }

      await this.fetchPreviews();
    }
  },
}
</script>
